import type { FC } from 'react';

import { copyrightStyle } from '@/features/storefront/appearance';
import { StorefrontContainer } from '@/features/storefront/components/StorefrontContainer';
import { useShopContent } from '@/features/storefront/content/useContent';
import { LanguageSwitcherSlot } from '@/features/storefront/i18n/LanguageSwitcher';
import { AppStoreBadges } from '@/features/storefront/layouts/chrome/FooterExtras';
import { InstallAppSlot } from '@/features/storefront/pwa/InstallAppSlot';
import {
  MenuLink,
} from '@/features/storefront/layouts/chrome/ChromeParts';
import { menuItems, type FooterProps } from '@/features/storefront/layouts/chrome/types';

/** One hairline row; says only what it must. */
export const Footer: FC<FooterProps> = ({ storeName, footer, menu, preview }) => {
  const items = menuItems(menu);
  const copy = useShopContent();
  return (
    <footer
      className="border-t py-6 text-xs"
      style={{ borderColor: 'var(--storefront-surface)', color: 'var(--storefront-muted)' }}
    >
      <StorefrontContainer className="flex flex-wrap items-center justify-between gap-x-8 gap-y-3">
        <InstallAppSlot preview={preview} />
        <AppStoreBadges footer={footer} preview={preview} className="mt-3" />
        <LanguageSwitcherSlot placement="footer" preview={preview} />
        <p style={copyrightStyle(footer)}>
          {storeName} · {copy('theme.powered_by', { brand: 'NeonCarts' })}
        </p>
        {items.length > 0 ? (
          <nav aria-label={menu?.name} className="flex flex-wrap items-center gap-x-5 gap-y-2">
            {items.map((item) => (
              <MenuLink
                key={`${item.label}:${item.url}`}
                item={item}
                preview={preview}
                className="hover:opacity-70"
              />
            ))}
          </nav>
        ) : null}
      </StorefrontContainer>
    </footer>
  );
};
